import { fg } from '@atlassian/jira-feature-gating';
import { globalLayout } from '@atlassian/jira-global-layout/src/index.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import ErrorPagesNotFound from '@atlassian/jira-router-routes-common/src/ui/error-pages/not-found/index.tsx';
import { helpCenterSettingsAnalyticsRoute } from '@atlassian/jira-router-routes-help-center-settings-routes/src/helpCenterSettingsAnalyticsRoute.tsx';
import { helpCenterSettingsAnalyticsRoutePageEntryPoint } from './ui/analytics/index.tsx';

export const helpCenterSettingsAnalyticsRouteEntry = createEntry(
	helpCenterSettingsAnalyticsRoute,
	() => ({
		group: 'customer-service',
		perfMetricKey: 'customer-service.analytics',
		layout: globalLayout,
		navigation: {
			menuId: MENU_ID.HELP_CENTER_SETTINGS,
		},
		component: ErrorPagesNotFound,
		entryPoint() {
			return fg('jcs-analytics-page') ? helpCenterSettingsAnalyticsRoutePageEntryPoint : undefined;
		},
		resources: [...getNavigationResources()],
	}),
);
